import Swiper from 'swiper/bundle';

// Function to mirror swiper
Swiper.prototype.mirror = function (otherSwiper) {
    function handleSwiperIndexChange (otherSwiper, currentIndex) {
        if (otherSwiper.realIndex !== currentIndex) {
            const slideToMethod = otherSwiper.originalParams.loop ? 'slideToLoop' : 'slideTo';
            otherSwiper[slideToMethod](currentIndex);
        }
    };

    this.on('activeIndexChange', () => {
        const { realIndex: currentIndex } = this;
        handleSwiperIndexChange(otherSwiper, currentIndex);
    });
};

window.theme.registerPackages({
    swiper: Swiper
});